import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, ChevronDown, Sparkles, Flower2, Sun, Wheat, Snowflake } from 'lucide-react';
import { ZoomableImage } from './ZoomableImage';

const PLAN = [
  {
    trimestre: 'Trimestre 1 — Énergie Hivernale',
    periode: 'Janvier • Février • Mars',
    icon: Snowflake,
    accent: 'text-sky-600',
    apero: 'Opéra de Foie Gras • Mini-Ceviche de crevette • Yakitori de bœuf',
    mois: [
      {
        nom: 'Janvier — Éveil Nikkei',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Classico', desc: 'Bar, maïs chulpi, patate douce.', img: '/generated/traiteur_ceviche_classico_34125e81.png' },
          { j: 'Mardi', nom: 'Poké Salmon Zen', desc: 'Saumon, avocat, riz vinaigré.', img: '/generated/traiteur_poke_salmon_zen_4b76ce31.png' },
          { j: 'Mercredi', nom: 'Ceviche Passion', desc: 'Daurade, fruit de la passion.', img: '/generated/traiteur_ceviche_passion_3fd5a9c3.png' },
          { j: 'Jeudi', nom: 'Poké Chicken', desc: 'Poulet Teriyaki, ananas.', img: '/generated/jan_poke_chicken_06253761.png' },
          { j: 'Vendredi', nom: 'Ceviche Nikkei', desc: 'Thon, soja, gingembre.', img: '/generated/jan_ceviche_nikkei_4d9c4035.png' },
        ],
      },
      {
        nom: 'Février — Douceur du Lac',
        jours: [
          { j: 'Lundi', nom: 'Ceviche de Féra', desc: 'Féra du Léman, aneth.' , img: '/generated/fev_ceviche_fera_45b6414b.png' },
          { j: 'Mardi', nom: 'Poké Shrimp', desc: 'Crevettes, mangue, wakamé.' , img: '/generated/fev_poke_shrimp_52c5d174.png' },
          { j: 'Mercredi', nom: 'Ceviche Coco', desc: 'Poisson blanc, lait de coco.' , img: '/generated/fev_ceviche_coco_ec99a2dc.png' },
          { j: 'Jeudi', nom: 'Poké Veggie', desc: 'Tofu fumé, grenade, quinoa.' , img: '/generated/fev_poke_veggie_7b8b6958.png' },
          { j: 'Vendredi', nom: 'Ceviche Citronnelle', desc: 'Crevettes, piment doux.' , img: '/generated/fev_ceviche_citronnelle_e4dce040.png' },
        ],
      },
      {
        nom: 'Mars — Transition Printanière',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Pulpo', desc: 'Poulpe, olives, tomate.' , img: '/generated/mar_ceviche_pulpo_4841d439.png' },
          { j: 'Mardi', nom: 'Poké Beef Tataki', desc: 'Bœuf mi-cuit, ponzu.' , img: '/generated/mar_poke_beef_tataki_882af3a0.png' },
          { j: 'Mercredi', nom: 'Ceviche Andin', desc: 'Truite, agrumes, quinoa.' , img: '/generated/mar_ceviche_andin_3ed456ae.png' },
          { j: 'Jeudi', nom: 'Poké Mediterranean', desc: 'Falafel, houmous, tahini.' , img: '/generated/mar_poke_mediterranean_8dd0674b.png' },
          { j: 'Vendredi', nom: 'Ceviche Palmier', desc: 'Cœurs de palmier, avocat (Veg).' , img: '/generated/mar_ceviche_palmier_fc06f4ca.png' },
        ],
      },
    ],
  },
  {
    trimestre: 'Trimestre 2 — Renaissance',
    periode: 'Avril • Mai • Juin',
    icon: Flower2,
    accent: 'text-pink-500',
    apero: 'Verrine asperge/truffe • Toast saumon • Brochette poulet satay',
    mois: [
      {
        nom: 'Avril — Fraîcheur Potagère',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Asperge', desc: "Bar et pointes d'asperges.", img: '/generated/avr_ceviche_asperge_0fbc23f0.png' },
          { j: 'Mardi', nom: 'Poké Green', desc: 'Saumon, fèves, petits pois.' , img: '/generated/avr_poke_green_b9704011.png' },
          { j: 'Mercredi', nom: 'Ceviche Lime', desc: 'Daurade, citron vert, radis.' , img: '/generated/avr_ceviche_lime_577bfca9.png' },
          { j: 'Jeudi', nom: 'Poké Crunch', desc: 'Poulet panko, slaw, soja.' , img: '/generated/avr_poke_crunch_8ec50561.png' },
          { j: 'Vendredi', nom: 'Ceviche Thon-Yuzu', desc: 'Thon, perles de yuzu.' , img: '/generated/avr_ceviche_thon_yuzu_f984e8a5.png' },
        ],
      },
      {
        nom: 'Mai — Jardin Exotique',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Mangue', desc: 'Crevettes, mangue, coriandre.' , img: '/generated/mai_ceviche_mangue_9d4eafc7.png' },
          { j: 'Mardi', nom: 'Poké Rainbow', desc: 'Thon, carotte, chou rouge.' , img: '/generated/mai_poke_rainbow_63817071.png' },
          { j: 'Mercredi', nom: 'Ceviche Menthe', desc: 'Lotte, menthe, concombre.' , img: '/generated/mai_ceviche_menthe_58c15c7b.png' },
          { j: 'Jeudi', nom: 'Poké Aloha', desc: 'Saumon, ananas, macadamia.' , img: '/generated/mai_poke_aloha_9c378de2.png' },
          { j: 'Vendredi', nom: 'Ceviche Truite', desc: 'Truite, baies roses, aneth.' , img: '/generated/mai_ceviche_truite_91318219.png' },
        ],
      },
      {
        nom: 'Juin — Saveurs Solaires',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Pêche', desc: 'Bar, pêche de vigne, basilic.' , img: '/generated/juin_ceviche_peche_f57b54c6.png' },
          { j: 'Mardi', nom: 'Poké Octopus', desc: 'Poulpe grillé, pommes de terre.' , img: '/generated/juin_poke_octopus_b7910680.png' },
          { j: 'Mercredi', nom: 'Ceviche Spicy', desc: 'Thon, jalapeño, oignon rouge.' , img: '/generated/juin_ceviche_spicy_34355440.png' },
          { j: 'Jeudi', nom: 'Poké Veggie Sun', desc: 'Halloumi, courgette, sésame.' , img: '/generated/juin_poke_veggie_sun_8313c4d7.png' },
          { j: 'Vendredi', nom: 'Ceviche Crevette-Litchi', desc: 'Crevettes, litchi, lime.' , img: '/generated/juin_ceviche_crevette_litchi_d338ff31.png' },
        ],
      },
    ],
  },
  {
    trimestre: 'Trimestre 3 — Plein Été',
    periode: 'Juillet • Août • Septembre',
    icon: Sun,
    accent: 'text-amber-500',
    apero: 'Gazpacho mangue/crabe • Saint-Jacques passion • Spring rolls',
    mois: [
      {
        nom: 'Juillet — Fraîcheur Marine',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Melón', desc: 'Daurade, melon, jambon cru.' , img: '/generated/juil_ceviche_melon_0c42f53c.png' },
          { j: 'Mardi', nom: 'Poké Ahi', desc: 'Thon rouge, algues, sésame.' , img: '/generated/juil_poke_ahi_1ab4230c.png' },
          { j: 'Mercredi', nom: 'Ceviche Pastèque', desc: 'Crevettes, pastèque, feta.' , img: '/generated/juil_ceviche_pasteque_dc7f9351.png' },
          { j: 'Jeudi', nom: 'Poké Calamar', desc: 'Calamar snacké, ail, citron.' , img: '/generated/juil_poke_calamar_cb6a8264.png' },
          { j: 'Vendredi', nom: 'Ceviche Veggie Fruit', desc: 'Avocat, mangue, grenade.' , img: '/generated/juil_ceviche_veggie_fruit_d94fff39.png' },
        ],
      },
      {
        nom: 'Août — Escapade Tropicale',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Coco-Lime', desc: 'Bar, lait de coco, zeste lime.' , img: '/generated/aout_ceviche_coco_lime_f2d4855a.png' },
          { j: 'Mardi', nom: 'Poké Tropical', desc: 'Crevettes, papaye, noix de coco.' , img: '/generated/aout_poke_tropical_3abeda85.png' },
          { j: 'Mercredi', nom: 'Ceviche de Moules', desc: 'Moules marinées, poivrons.' , img: '/generated/aout_ceviche_moules_dccf8dcf.png' },
          { j: 'Jeudi', nom: 'Poké BBQ Chicken', desc: 'Poulet effiloché, maïs grillé.' , img: '/generated/aout_poke_bbq_chicken_58ecec85.png' },
          { j: 'Vendredi', nom: 'Ceviche Thon-Gingembre', desc: 'Thon, gingembre frais, soja.' , img: '/generated/aout_ceviche_thon_gingembre_c3bcbb61.png' },
        ],
      },
      {
        nom: 'Septembre — Récoltes & Terroir',
        jours: [
          { j: 'Lundi', nom: 'Ceviche de Loup', desc: 'Loup, raisin, amandes effilées.' , img: '/generated/sep_ceviche_loup_72ed00ab.png' },
          { j: 'Mardi', nom: 'Poké Fall', desc: 'Saumon, pomme, noix.' , img: '/generated/sep_poke_fall_016d715f.png' },
          { j: 'Mercredi', nom: 'Ceviche Tomate', desc: 'Daurade, tomates anciennes.' , img: '/generated/sep_ceviche_tomate_b441eea8.png' },
          { j: 'Jeudi', nom: 'Poké Tempeh', desc: 'Tempeh grillé, brocoli, miso.' , img: '/generated/sep_poke_tempeh_25cc1a7b.png' },
          { j: 'Vendredi', nom: 'Ceviche Pétoncles', desc: 'Pétoncles, agrumes, coriandre.' , img: '/generated/sep_ceviche_petoncles_193ecf0f.png' },
        ],
      },
    ],
  },
  {
    trimestre: 'Trimestre 4 — Réconfort & Fêtes',
    periode: 'Octobre • Novembre • Décembre',
    icon: Wheat,
    accent: 'text-orange-600',
    apero: "Blinis caviar • Croustillant d'agneau • Mini-burger panko",
    mois: [
      {
        nom: 'Octobre — Bois & Forêt',
        jours: [
          { j: 'Lundi', nom: 'Ceviche de Champignons', desc: 'Champignons de Paris, truffe.' , img: '/generated/oct_ceviche_champignons_9d7b10c4.png' },
          { j: 'Mardi', nom: 'Poké Duck', desc: 'Canard laqué, figues, riz noir.' , img: '/generated/oct_poke_duck_f51db55c.png' },
          { j: 'Mercredi', nom: 'Ceviche de Truite', desc: 'Truite fumée, crème, aneth.' , img: '/generated/oct_ceviche_truite_fumee_395ea245.png' },
          { j: 'Jeudi', nom: 'Poké Squash', desc: 'Courge rôtie, féta, noisettes.' , img: '/generated/oct_poke_squash_6aa3a746.png' },
          { j: 'Vendredi', nom: 'Ceviche de Thon-Figue', desc: 'Thon, figue fraîche, balsamique.' , img: '/generated/oct_ceviche_thon_figue_f3adac55.png' },
        ],
      },
      {
        nom: 'Novembre — Brumes & Saveurs',
        jours: [
          { j: 'Lundi', nom: 'Ceviche de Saint-Jacques', desc: 'Saint-Jacques, clémentine.' , img: '/generated/nov_ceviche_stjacques_clem_63897ad9.png' },
          { j: 'Mardi', nom: 'Poké Smoky', desc: 'Saumon fumé, cream cheese.' , img: '/generated/nov_poke_smoky_8ad0ff82.png' },
          { j: 'Mercredi', nom: 'Ceviche de Cabillaud', desc: 'Cabillaud, poireau, citron.' , img: '/generated/nov_ceviche_cabillaud_2912369a.png' },
          { j: 'Jeudi', nom: 'Poké Beef Asian', desc: 'Bœuf, shiitake, oignons frits.' , img: '/generated/nov_poke_beef_asian_0d0715e4.png' },
          { j: 'Vendredi', nom: 'Ceviche Crevettes-Poire', desc: 'Crevettes, poire, noix.' , img: '/generated/nov_ceviche_crevettes_poire_4c2ef075.png' },
        ],
      },
      {
        nom: 'Décembre — Prestige & Gala',
        jours: [
          { j: 'Lundi', nom: 'Ceviche Royal Homard', desc: 'Homard, truffe noire, citron.' , img: '/generated/dec_ceviche_royal_homard_a30146ce.png' },
          { j: 'Mardi', nom: 'Poké Festive Thon', desc: 'Thon, œuf de caille, caviar.' , img: '/generated/dec_poke_festive_thon_145d7a70.png' },
          { j: 'Mercredi', nom: "Ceviche de Bar-Or", desc: "Bar, agrumes, feuille d'or.", img: '/generated/dec_ceviche_bar_or_7ca78c81.png' },
          { j: 'Jeudi', nom: 'Poké Foie Gras Fusion', desc: 'Dés de foie gras, mangue.' , img: '/generated/dec_poke_foie_gras_69f62f5c.png' },
          { j: 'Vendredi', nom: 'Ceviche Saint-Jacques-Yuzu', desc: 'Saint-Jacques, yuzu, grenade.' , img: '/generated/dec_ceviche_stjacques_yuzu_2f8b1650.png' },
        ],
      },
    ],
  },
];

export const MenuCardTraiteurAnnuel = () => {
  const [openTrim, setOpenTrim] = useState(0);

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-5xl mx-auto"
      data-testid="traiteur-annuel"
    >
      {/* Header */}
      <div className="bg-gradient-to-br from-navy to-[#2a3142] rounded-2xl px-8 py-10 text-center mb-8 shadow-xl border-b-4 border-terracotta">
        <div className="flex items-center justify-center gap-3 mb-2">
          <span className="w-12 h-[1px] bg-terracotta"></span>
          <Calendar className="text-terracotta" size={26} />
          <span className="w-12 h-[1px] bg-terracotta"></span>
        </div>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white tracking-wide">
          Planification Annuelle Traiteur
        </h2>
        <p className="text-white/85 mt-3 italic font-heading text-lg">
          12 mois • Rotation quotidienne (Lundi-Vendredi) • Suggestions Apéro Dînatoire
        </p>
      </div>

      {/* Trimestres accordéons */}
      <div className="space-y-4">
        {PLAN.map((t, idx) => {
          const Icon = t.icon;
          const isOpen = openTrim === idx;
          return (
            <div key={t.trimestre} className="bg-[#FAF8F4] rounded-2xl border border-[#D4C4AA]/40 shadow-card overflow-hidden">
              <button
                onClick={() => setOpenTrim(isOpen ? -1 : idx)}
                className="w-full flex items-center justify-between px-6 py-5 hover:bg-terracotta/5 transition-colors"
                data-testid={`trim-${idx}`}
              >
                <div className="flex items-center gap-4 text-left">
                  <div className={`w-11 h-11 rounded-xl bg-white flex items-center justify-center shadow-sm ${t.accent}`}>
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-navy">{t.trimestre}</h3>
                    <p className="text-navy/60 text-sm italic">{t.periode}</p>
                  </div>
                </div>
                <ChevronDown size={24} className={`text-terracotta transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>

              {isOpen && (
                <div className="px-6 pb-6 space-y-8">
                  {t.mois.map((m) => (
                    <div key={m.nom}>
                      <h4 className="font-heading text-base font-bold text-terracotta tracking-widest uppercase mb-3 text-center">
                        {m.nom}
                      </h4>
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm border-collapse">
                          <thead>
                            <tr className="bg-[#D4C4AA]/30">
                              <th className="text-left px-4 py-3 font-bold text-navy w-28">Jour</th>
                              <th className="text-left px-4 py-3 font-bold text-navy w-64">Suggestion</th>
                              <th className="text-left px-4 py-3 font-bold text-navy">Composition</th>
                            </tr>
                          </thead>
                          <tbody>
                            {m.jours.map((j) => (
                              <tr key={j.j} className="border-t border-[#D4C4AA]/30 hover:bg-terracotta/5 transition-colors">
                                <td className="px-4 py-3 font-bold text-navy align-top">{j.j}</td>
                                <td className="px-4 py-3 align-top">
                                  <div className="flex items-start gap-3">
                                    {j.img && (
                                      <ZoomableImage
                                        src={j.img}
                                        alt={j.nom}
                                        className="w-20 h-20 object-cover rounded-lg flex-shrink-0 shadow-sm"
                                        loading="lazy"
                                      />
                                    )}
                                    <div className="pt-1">
                                      <p className="text-navy font-heading font-semibold">{j.nom}</p>
                                    </div>
                                  </div>
                                </td>
                                <td className="px-4 py-3 text-navy/75 italic align-top">{j.desc}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}

                  {/* Apéro suggestion */}
                  <div className="bg-white rounded-2xl p-5 border border-terracotta/30 flex items-start gap-3">
                    <Sparkles size={22} className="text-terracotta flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-heading font-bold text-navy text-sm tracking-widest uppercase mb-1">
                        Apéro Dînatoire — Trimestre {idx + 1}
                      </p>
                      <p className="text-navy/80 italic">{t.apero}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="text-center mt-8">
        <p className="text-navy/70 text-sm italic">
          Formule traiteur personnalisée • Devis sur demande • Contact : <a href="mailto:contact@racines-epices-dumonde.ch" className="text-terracotta hover:underline">contact@racines-epices-dumonde.ch</a>
        </p>
      </div>
    </motion.section>
  );
};
